<template>
  <div class="ma-4">
    <Snackbar :text="text" :snackbar="snackbar" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4">Atualizar Conferência - {{ titleConferencia }}</div>
      <v-row dense class="mt-10">
        <v-col cols="4">
          <v-text-field
            counter="30"
            :error-messages="descriptionErrors"
            dense
            outlined
            v-model="form.description"
            label="Descrição"
            @input="$v.form.description.$touch()"
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            counter="4"
            type="number"
            :error-messages="senhaErrors"
            dense
            outlined
            v-model="form.senha"
            label="Senha (opcional)"
            @input="$v.form.senha.$touch()"
            @blur="$v.form.senha.$touch()"
          />
        </v-col>
        <v-col cols="4" class="mt-n3 ml-4">
          <v-switch dense v-model="form.record" label="Grava Conferência?" />
        </v-col>
      </v-row>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import { registerVuexModule } from '@/utils/vuexUtils'
import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'

import conferenciaStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import conferenciaHttpStore from '../_services/conferenciaHttpService'

export default {
  props: {
    _id: String,
  },
  components: { FixedButtons, Snackbar },
  mixins: [validationMixin],
  data: () => ({
    showSkeleton: false,
    snackbar: false,
    text: '',
    titleConferencia: '',
    form: {
      description: '',
      senha: '',
      record: true,
    },
    pararLoader: {
      parar: false,
    },
  }),

  computed: {
    ...validateComputed,
    ...mapGetters('atualizarConferenciaModulePABXStore', ['getConferencia']),
  },

  validations: {
    ...validateData,
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'atualizarConferenciaModulePABXStore', conferenciaStore)

    await this.listarUmaConferencia(this._id)

    this.titleConferencia = this.getConferencia.description

    this.form.description = this.getConferencia.description
    this.form.record = this.getConferencia.record
    this.form.senha = this.getConferencia.senha

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('atualizarConferenciaModulePABXStore', ['listarUmaConferencia']),

    cancelar() {
      this.$router.push({ name: 'Conferencia' })
    },

    async salvar() {
      this.pararLoader.parar = false

      try {
        await conferenciaHttpStore.putConferencia(this.form, this._id)
        this.$router.push({ name: 'Conferencia' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
  },
}
</script>
